// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"13093568","66":"e9f479cc","76":"11dcda69","93":"86d356f3","133":"95d0ed2e","197":"52a6a2bd","296":"55ae83b7","473":"dc11d61e","488":"6033013d","528":"29e62f35","672":"7f1fd96e","717":"5a80882d","821":"193677f7"}[chunkId] + ".chunk.js";
};